import React from "react";

function AddressIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
    >
      <path
        d="M6.74062 14.6629C8.34375 12.7772 12 8.20679 12 5.63959C12 2.52607 9.3125 0 6 0C2.6875 0 0 2.52607 0 5.63959C0 8.20679 3.65625 12.7772 5.25938 14.6629C5.64375 15.1124 6.35625 15.1124 6.74062 14.6629ZM6 3.75973C6.53043 3.75973 7.03914 3.95779 7.41421 4.31033C7.78929 4.66287 8 5.14102 8 5.63959C8 6.13817 7.78929 6.61632 7.41421 6.96886C7.03914 7.3214 6.53043 7.51946 6 7.51946C5.46957 7.51946 4.96086 7.3214 4.58579 6.96886C4.21071 6.61632 4 6.13817 4 5.63959C4 5.14102 4.21071 4.66287 4.58579 4.31033C4.96086 3.95779 5.46957 3.75973 6 3.75973Z"
        fill="#9CA3AF"
      />
    </svg>
  );
}

export default AddressIcon;
